module.exports = __webpack_public_path__ + "img/PL08938.849d8d60.png";